module.exports = __webpack_public_path__ + "static/media/co11.b194db83.png";